import actions from "./actions";
import mutations from "./mutation";
import state from "./state";
import getters from "./getters";

const admin = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
export default admin;